var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("div", { staticClass: "ibox sombra-light" }, [
        _c("div", { staticClass: "ibox-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-tools" }, [
            _c(
              "button",
              { staticClass: "btn-primary", on: { click: _vm.agregar } },
              [
                _vm._v(
                  _vm._s(!_vm.nuevo && !_vm.editando ? "Agregar" : "Volver")
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        !_vm.nuevo && !_vm.editando
          ? _c(
              "div",
              { staticClass: "ibox-content" },
              [
                _c("data-table", {
                  attrs: {
                    id: _vm.dt.id,
                    datos: _vm.dt.datos,
                    columnas: _vm.dt.columnas,
                    responsive: true,
                    "font-size": 12,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activo",
                        fn: function (item) {
                          return [
                            _c("switchh", {
                              staticClass: "ml-4 mt-2",
                              attrs: { isEnabled: item.data.activo },
                              on: {
                                toggle: function ($event) {
                                  return _vm.activar(item.data)
                                },
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "opciones",
                        fn: function (item) {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-gray",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editar(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\r\n                            Editar\r\n                        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    681878409
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.nuevo || _vm.editando
          ? _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.save.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "ibox-content" },
                  [
                    _c("b-overlay", { attrs: { rounded: "sm" } }, [
                      _c("div", { staticClass: "container" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("h2", [_vm._v("Discord")]),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                          ]),
                          _vm._v(" "),
                          _vm.discord_local && _vm.discord_local.activo
                            ? _c("div", { staticClass: "col-6" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [_vm._v("Nombre")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.discord_local.nombre,
                                        expression: "discord_local.nombre",
                                      },
                                    ],
                                    staticClass: "form-control ",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.discord_local.nombre,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.discord_local,
                                          "nombre",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.discord_local && _vm.discord_local.activo
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [_vm._v("URL")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.discord_local.url,
                                        expression: "discord_local.url",
                                      },
                                    ],
                                    staticClass: "form-control ",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.discord_local.url },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.discord_local,
                                          "url",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("hr"),
                        ]),
                        _vm._v(" "),
                        _vm.discord_local && _vm.discord_local.activo
                          ? _c("div", [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [_c("h2", [_vm._v("Menciones")])]
                                  ),
                                  _vm._v(" "),
                                  _c("hr"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-group text-center" },
                                    [
                                      _c("multiselect", {
                                        attrs: {
                                          options: _vm.menciones,
                                          multiple: true,
                                          "track-by": "value",
                                          label: "text",
                                          "close-on-select": false,
                                          "hide-selected": true,
                                          selectLabel:
                                            "Presione para seleccionar",
                                          "open-direction": "bottom",
                                          placeholder: "Todos",
                                        },
                                        model: {
                                          value: _vm.discord_local.etiquetas,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.discord_local,
                                              "etiquetas",
                                              $$v
                                            )
                                          },
                                          expression: "discord_local.etiquetas",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("h2", [
                                    _vm._v("Proveedores y Parametros"),
                                  ]),
                                  _vm._v(" "),
                                  _c("hr"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.discord_local.parametros_activos.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "row mb-2" },
                                    [
                                      _c("div", { staticClass: "col-12" }, [
                                        _c("label", [_vm._v("Activos")]),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.discord_local.parametros_activos,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "col-3 text-center mb-2",
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      border: "1px solid #eee",
                                                      "border-radius": "5px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "text-align": "end",
                                                          "margin-right":
                                                            "13px",
                                                          "margin-left": "10px",
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.eliminar(
                                                              item,
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-times",
                                                          staticStyle: {
                                                            color: "red",
                                                          },
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _c("div", [
                                                        _vm._v(
                                                          "\r\n                                                        Proveedor: " +
                                                            _vm._s(
                                                              item.proveedor
                                                            ) +
                                                            "\r\n                                                    "
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          "\r\n                                                        Metodo: " +
                                                            _vm._s(
                                                              item.metodo
                                                            ) +
                                                            "\r\n                                                    "
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c("label", [_vm._v("Agregar")]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-group text-center" },
                                    [
                                      _c("label", [_vm._v("Proveedor")]),
                                      _vm._v(" "),
                                      _c("multiselect", {
                                        attrs: {
                                          options: _vm.proveedores_local,
                                          "track-by": "value",
                                          label: "text",
                                          "close-on-select": true,
                                          "hide-selected": true,
                                          selectLabel:
                                            "Presione para seleccionar",
                                          "open-direction": "bottom",
                                          placeholder: "Todos",
                                        },
                                        model: {
                                          value: _vm.proveedor,
                                          callback: function ($$v) {
                                            _vm.proveedor = $$v
                                          },
                                          expression: "proveedor",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.proveedor
                                  ? _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group text-center",
                                        },
                                        [
                                          _c("label", [_vm._v("Proveedor")]),
                                          _vm._v(" "),
                                          _c("multiselect", {
                                            attrs: {
                                              options:
                                                _vm.paramentros_proveedor,
                                              "track-by": "value",
                                              label: "text",
                                              "close-on-select": true,
                                              "hide-selected": true,
                                              selectLabel:
                                                "Presione para seleccionar",
                                              "open-direction": "bottom",
                                              placeholder: "Todos",
                                            },
                                            on: { select: _vm.selecciona },
                                            model: {
                                              value: _vm.parametro,
                                              callback: function ($$v) {
                                                _vm.parametro = $$v
                                              },
                                              expression: "parametro",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("h2", [_vm._v("Codigos")]),
                                  _vm._v(" "),
                                  _c("hr"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-group text-center" },
                                    [
                                      _c("multiselect", {
                                        attrs: {
                                          options: _vm.codigos_local,
                                          multiple: true,
                                          "track-by": "value",
                                          label: "text",
                                          "close-on-select": false,
                                          "hide-selected": true,
                                          selectLabel:
                                            "Presione para seleccionar",
                                          "open-direction": "bottom",
                                          placeholder: "Todos",
                                        },
                                        model: {
                                          value: _vm.discord_local.codigos,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.discord_local,
                                              "codigos",
                                              $$v
                                            )
                                          },
                                          expression: "discord_local.codigos",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("h2", [_vm._v("Imagen")]),
                                      _vm._v(" "),
                                      _c("switchh", {
                                        staticClass: "ml-4 mt-2",
                                        attrs: {
                                          isEnabled: _vm.activos.imagen,
                                        },
                                        on: {
                                          toggle: function ($event) {
                                            return _vm.toggle("imagen")
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("hr"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.activos.imagen
                                ? _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group text-center",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.discord_local.form.imagen,
                                                expression:
                                                  "discord_local.form.imagen",
                                              },
                                            ],
                                            staticClass: "form-control ",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                _vm.discord_local.form.imagen,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.discord_local.form,
                                                  "imagen",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("h2", [_vm._v("Color")]),
                                      _vm._v(" "),
                                      _c("switchh", {
                                        staticClass: "ml-4 mt-2",
                                        attrs: { isEnabled: _vm.activos.color },
                                        on: {
                                          toggle: function ($event) {
                                            return _vm.toggle("color")
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("hr"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.activos.color
                                ? _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group text-center",
                                          attrs: { st: "" },
                                        },
                                        [
                                          _c("chrome", {
                                            model: {
                                              value:
                                                _vm.discord_local.form.color,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.discord_local.form,
                                                  "color",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "discord_local.form.color",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("h2", [_vm._v("Mensaje")]),
                                  _vm._v(" "),
                                  _c("hr"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-6 msg-body-col" },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12",
                                          attrs: { id: "mensaje-section" },
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "hr-line-dashed",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            { staticClass: "text-center" },
                                            [_c("b", [_vm._v("Mensaje")])]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "Ingrese el mensaje que desea enviar, puede utilizar etiquetas, emojis y dar formato al texto."
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12",
                                          attrs: {
                                            id: "mensaje-input-section",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "input-group" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-addon",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fal fa-comments",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.discord_local.form
                                                            .mensaje,
                                                        expression:
                                                          "discord_local.form.mensaje",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control no-resize",
                                                    attrs: {
                                                      name: "",
                                                      id: "",
                                                      cols: "30",
                                                      rows: "10",
                                                      placeholder: "Mensaje",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.discord_local.form
                                                          .mensaje,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.discord_local
                                                            .form,
                                                          "mensaje",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", {
                                                attrs: {
                                                  id: "cantidad_caracteres_body",
                                                },
                                              }),
                                              _vm._v(
                                                " (Max 1024)\r\n\r\n                                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-6 msg-body-col" },
                                  [
                                    _c("div", {
                                      staticClass: "hr-line-dashed",
                                    }),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v("Etiquetas ("),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "text-navy",
                                          attrs: {
                                            "data-toggle": "popover",
                                            "data-placement": "auto",
                                            "data-content":
                                              "Utiliza estas etiquetas para decidir los datos personalizados a enviar.",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-question-circle",
                                          }),
                                        ]
                                      ),
                                      _vm._v(")"),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-justify" }, [
                                      _vm._v(
                                        "\r\n                                            Si usted lo desea, puede incluir las etiquetas que se describen a continuación. Para incluir\r\n                                            dichas etiquetas debe escribir (incluyendo los "
                                      ),
                                      _c("code", [_vm._v("{{")]),
                                      _vm._v(" "),
                                      _c("code", [_vm._v("}}")]),
                                      _vm._v(
                                        " y en\r\n                                            "
                                      ),
                                      _c("strong", [_vm._v("MAYÚSCULAS")]),
                                      _vm._v("):"),
                                      _c("br"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "row" },
                                      _vm._l(
                                        _vm.etiquetas,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "col-md-6",
                                            },
                                            [
                                              _c("code", [
                                                _vm._v(
                                                  _vm._s(item.nombre) + " "
                                                ),
                                              ]),
                                              _vm._v(
                                                "\r\n                                                ("
                                              ),
                                              item.descripcion
                                                ? _c(
                                                    "a",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "popover-target",
                                                          rawName:
                                                            "v-popover-target",
                                                          value:
                                                            index.toString(),
                                                          expression:
                                                            "index.toString()",
                                                        },
                                                      ],
                                                      staticClass: "text-navy",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-question-circle",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                ")\r\n                                                "
                                              ),
                                              _c(
                                                "popover",
                                                {
                                                  attrs: {
                                                    name: index.toString(),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                                                    " +
                                                      _vm._s(item.descripcion) +
                                                      "\r\n                                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("h2", [_vm._v("Footer")]),
                                      _vm._v(" "),
                                      _c("switchh", {
                                        staticClass: "ml-4 mt-2",
                                        attrs: {
                                          isEnabled: _vm.activos.footer,
                                        },
                                        on: {
                                          toggle: function ($event) {
                                            return _vm.toggle("footer")
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("hr"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.activos.footer
                                ? _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group text-center",
                                        },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Texto"),
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.discord_local.form.footer
                                                    .text,
                                                expression:
                                                  "discord_local.form.footer.text",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                _vm.discord_local.form.footer
                                                  .text,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.discord_local.form.footer,
                                                  "text",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group text-center",
                                        },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Imagen"),
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.discord_local.form.footer
                                                    .url_image,
                                                expression:
                                                  "discord_local.form.footer.url_image",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                _vm.discord_local.form.footer
                                                  .url_image,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.discord_local.form.footer,
                                                  "url_image",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col",
                              staticStyle: { "text-align": "end" },
                            },
                            [
                              _c("button", { staticClass: "btn btn-primary" }, [
                                _vm._v("Guardar"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-bar" }),
      _vm._v(
        " Configuracion de\r\n                    discord\r\n                "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }